import { HttpService } from '@/data/http/http-service';
import {
  EssQuestions,
  EssQuestionValue,
} from '@/domain/impact-ess/entities/question.entity';
import { ImpactEssGateway } from '@/domain/impact-ess/gateways/impact-ess.gateway';

import {
  getImpactAnswersResponsesDtoSchema,
  getModelParametersDtoSchema,
} from './impact-ess.dto.schema';

export class ApiImpactEssHttpGateway implements ImpactEssGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  async getImpactEssQuestions(modelVersion: string): Promise<EssQuestions> {
    const url = '/model-parameters/ess';
    const options = {
      additionalHeaders: { 'x-model-version': modelVersion },
    }; //modelVersion } };
    const response = await this.http.get(url, options);
    const result = getModelParametersDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const modelParameters: EssQuestions = result.data;
    return modelParameters;
  }

  async getImpactEssResponses(projectId: number): Promise<EssQuestionValue[]> {
    const url = `/ess-values?projectId=${projectId}`;
    const response = await this.http.get(url);
    const result = getImpactAnswersResponsesDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const responses: EssQuestionValue[] = result.data;
    return responses;
  }

  async createImpactEssResponse(
    projectId: number,
    paramId: string,
    value: string,
    modelVersion: string,
  ): Promise<void> {
    const url = '/ess-values';
    const data = {
      paramId: paramId,
      value: value,
      projectId: projectId,
      modelVersion,
    };
    await this.http.post(url, data);
  }

  async editImpactEssResponse(answerId: number, value: string): Promise<void> {
    const url = `/ess-values/${answerId}`;
    const data = { value };
    await this.http.patch(url, data);
  }
}
